var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12.5,
    cy: 6.5,
    r: 6.5,
    fill: "#F5C87B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8.78793 16 9.56815 15.8448 10.2961 15.5433C11.0241 15.2417 11.6855 14.7998 12.2426 14.2426C12.7998 13.6855 13.2417 13.0241 13.5433 12.2961C13.8448 11.5681 14 10.7879 14 10C14 9.21207 13.8448 8.43185 13.5433 7.7039C13.2417 6.97595 12.7998 6.31451 12.2426 5.75736C11.6855 5.20021 11.0241 4.75825 10.2961 4.45672C9.56815 4.15519 8.78793 4 8 4C6.4087 4 4.88258 4.63214 3.75736 5.75736C2.63214 6.88258 2 8.4087 2 10C2 11.5913 2.63214 13.1174 3.75736 14.2426C4.88258 15.3679 6.4087 16 8 16V16Z",
    stroke: "#F5C87B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.66602V9.99935L10 11.9993",
    stroke: "#F5C87B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.2eb74ee162fa2f2bed756ec67cb28283.svg";
export { ForwardRef as ReactComponent };